const SHIPPING_PROGRESS_CONTAINER_ID = 'smart-cart-shipping-progress';
const SHIPPING_PROGRESS_DEFAULT_TIER_2_THRESHOLD = 16000;
const SHIPPING_PROGRESS_DEFAULT_TIER_3_THRESHOLD = 19000;

const SHIPPING_PROGRESS_ICON_CHECK_OUTLINE = `
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M12.5 7.25C12.5 10.1495 10.1495 12.5 7.25 12.5C4.35051 12.5 2 10.1495 2 7.25C2 4.35051 4.35051 2 7.25 2C10.1495 2 12.5 4.35051 12.5 7.25Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.30566 7.62023L6.18406 8.62411C6.43104 8.90637 6.87637 8.88557 7.09596 8.58152L9.19455 5.67578" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const SHIPPING_PROGRESS_ICON_CHECK_LIGHT = `
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M12.5 7.25C12.5 10.1495 10.1495 12.5 7.25 12.5C4.3505 12.5 2 10.1495 2 7.25C2 4.3505 4.3505 2 7.25 2C10.1495 2 12.5 4.3505 12.5 7.25Z" fill="#ACE0BA" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.30566 7.62023L6.18406 8.62411C6.43104 8.90637 6.87637 8.88557 7.09596 8.58152L9.19455 5.67578" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const SHIPPING_PROGRESS_ICON_BOX = `
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
    <path d="M3.26543 3.19204L7.9321 0.545916C8.0358 0.484695 8.17408 0.484695 8.27778 0.545916L12.9445 3.19868V8.4365C12.9445 8.56574 12.8753 8.67458 12.7716 8.7358L8.10494 11.3887L3.43827 8.7358C3.33457 8.67458 3.26543 8.56574 3.26543 8.4433V3.19868L8.10494 5.94683M8.10494 5.94683V11.3887M8.10494 5.94683L12.9445 3.19868M3.26543 4.40294H1.3642M3.26543 5.9471H0.5M3.26543 7.48443H1.3642" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const getShippingProgressThresholds = (container) => {
  const tier2 = Number(container.dataset.tier2Threshold);
  const tier3 = Number(container.dataset.tier3Threshold);

  return {
    tier2: Number.isFinite(tier2) && tier2 > 0 ? tier2 : SHIPPING_PROGRESS_DEFAULT_TIER_2_THRESHOLD,
    tier3: Number.isFinite(tier3) && tier3 > 0 ? tier3 : SHIPPING_PROGRESS_DEFAULT_TIER_3_THRESHOLD,
  };
};

// The 160/190 zł tiers only apply to one-time purchases; a cart made entirely of subscription
// items follows its own separate 69 zł free-shipping rule instead, so neither progress bar applies.
const isSubscriptionOnlyCart = (cart) => {
  const items = Array.isArray(cart?.items) ? cart.items : [];
  return items.length > 0 && items.every((item) => !!item.selling_plan_allocation);
};

const updateShippingProgressBar = () => {
  const container = document.getElementById(SHIPPING_PROGRESS_CONTAINER_ID);
  if (!container) return;
  const cart = window.Rebuy?.SmartCart?.cart;
  if (!cart) return;

  // Hidden for subscription-only carts (different 69 zł rule applies), and also for mixed carts
  // where the subscription portion alone already clears that 69 zł threshold - shipping is already
  // free at that point regardless of the 160/190 zł one-time tiers.
  const shouldHide = isSubscriptionOnlyCart(cart) || hasRealFreeShipping(cart);
  container.classList.toggle('is-hidden', shouldHide);
  if (shouldHide) return;

  const { tier2, tier3 } = getShippingProgressThresholds(container);
  const totalPrice = Number(cart.total_price) || 0;

  const reachedTier2 = totalPrice >= tier2;
  const reachedTier3 = totalPrice >= tier3;
  const currentStage = reachedTier3 ? 3 : reachedTier2 ? 2 : 1;

  container.querySelectorAll('.smart-cart-shipping-progress__stop').forEach((stop) => {
    const stopIndex = Number(stop.dataset.stop);
    const isReached = stopIndex <= currentStage;

    stop.classList.toggle('is-reached', isReached);

    const icon = stop.querySelector('[data-icon]');
    if (icon) {
      if (stopIndex === 2) {
        if (currentStage === 1) icon.innerHTML = SHIPPING_PROGRESS_ICON_BOX;
        else if (currentStage === 2) icon.innerHTML = SHIPPING_PROGRESS_ICON_CHECK_LIGHT;
        else icon.innerHTML = SHIPPING_PROGRESS_ICON_CHECK_OUTLINE;
      } else if (stopIndex === 3) {
        icon.innerHTML = currentStage === 3 ? SHIPPING_PROGRESS_ICON_CHECK_LIGHT : SHIPPING_PROGRESS_ICON_BOX;
      }
    }
  });

  const lineFill1 = container.querySelector('[data-line-fill="1"]');
  const lineFill2 = container.querySelector('[data-line-fill="2"]');

  // Segment 2 mirrors the footer bar's scale (0 -> tier3) rather than its own narrow 160-190 zł
  // sub-range, so both bars convey the same "closeness to free shipping" for the same cart total.
  const segment1Percent = Math.max(0, Math.min(100, (totalPrice / tier2) * 100));
  const segment2Percent = totalPrice <= tier2 ? 0 : Math.max(0, Math.min(100, (totalPrice / tier3) * 100));

  if (lineFill1) lineFill1.style.width = `${segment1Percent}%`;
  if (lineFill2) lineFill2.style.width = `${segment2Percent}%`;
};

const FOOTER_SHIPPING_PROGRESS_CONTAINER_ID = 'smart-cart-footer-shipping-progress';
const FOOTER_SHIPPING_PROGRESS_INFO_BUTTON_ID = 'smart-cart-footer-shipping-progress-info-button';
const FOOTER_SHIPPING_PROGRESS_INFO_MODAL_ID = 'smart-cart-shipping-progress-info-modal';

const formatShippingProgressMoney = (cents) => {
  const value = (cents / 100).toFixed(2);
  return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(value);
};

const ensureShippingProgressInfoModal = () => {
  let modal = document.getElementById(FOOTER_SHIPPING_PROGRESS_INFO_MODAL_ID);
  if (modal) return modal;

  modal = document.createElement('div');
  modal.id = FOOTER_SHIPPING_PROGRESS_INFO_MODAL_ID;
  modal.style.position = 'fixed';
  modal.style.inset = '0';
  modal.style.zIndex = '9999999999';
  modal.style.display = 'none';
  modal.style.alignItems = 'center';
  modal.style.justifyContent = 'center';
  modal.innerHTML = `
    <div data-modal-close="overlay" class="absolute inset-0"></div>
    <div class="relative bg-white py-10 px-6 max-w-sm mx-auto rounded-lg w-[min(92vw,420px)] shadow-md">
      <button type="button" data-modal-close="button" class="absolute pointer top-[18px] right-[18px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <path d="M12.5 0.5L0.5 12.5M0.5 0.5L12.5 12.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="mb-5 font-semibold text-s flex items-center gap-1.5">Koszt dostawy zależy od wartości zamówienia:</div>
      <div class="flex justify-between items-center pb-3 text-s border-b border-[#c7c7c7]">
        <span class="leading-[18.85px] tracking-[0.13px] font-semibold">do 159,99 zł</span>
        <span class="font-semibold tracking-[0.24px] leading-[14.4px]">15,99 zł</span>
      </div>
      <div class="flex justify-between items-center mt-3 pb-3 text-s border-b border-[#c7c7c7]">
        <span class="leading-[18.85px] tracking-[0.13px] font-semibold">od 160 zł</span>
        <span class="font-semibold tracking-[0.24px] leading-[14.4px]">7,99 zł</span>
      </div>
      <div class="flex justify-between items-center text-s mt-3">
        <span class="leading-[18.85px] tracking-[0.13px] font-semibold">od 190 zł</span>
        <span class="text-green font-semibold tracking-[0.24px] leading-[14.4px]">Dostawa gratis</span>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  modal.addEventListener('click', (event) => {
    if (!event.target.closest('[data-modal-close]')) return;
    modal.style.display = 'none';
  });

  return modal;
};

const openShippingProgressInfoModal = () => {
  const modal = ensureShippingProgressInfoModal();
  modal.style.display = 'flex';
};

const setShippingProgressInfoButtonListener = () => {
  const button = document.getElementById(FOOTER_SHIPPING_PROGRESS_INFO_BUTTON_ID);
  if (!button) return;

  button.removeEventListener('click', openShippingProgressInfoModal);
  button.addEventListener('click', openShippingProgressInfoModal);
};

// Note: intentionally ignores the flat "159 zł for all items" free-shipping rule (window.ykFreeShippingDecimal)
// since it sits below our own tier2 threshold (160 zł) and would hide these widgets before the 7,99 zł tier
// ever gets a chance to show. Only genuinely different scenarios (subscription orders, digital-only carts)
// short-circuit completion here; everything else defers to our own tier3 threshold.
const hasRealFreeShipping = (cart) => {
  try {
    const { digitalProductsTotalValue } = handleDigitalProductsInCart();
    const hasFreeShippingSub = isFreeShippingSub();
    const hasOnlyDigitalProducts = digitalProductsTotalValue > 0 && digitalProductsTotalValue === cart.total_price;

    return hasFreeShippingSub || hasOnlyDigitalProducts;
  } catch (e) {
    return false;
  }
};

const updateFooterShippingProgress = () => {
  const container = document.getElementById(FOOTER_SHIPPING_PROGRESS_CONTAINER_ID);
  const summary = document.getElementById('yk-smart-cart-summary');
  if (!container) return;
  const cart = window.Rebuy?.SmartCart?.cart;
  if (!cart) return;

  const isSubscriptionOnly = isSubscriptionOnlyCart(cart);
  summary?.classList.toggle('subscription-only-shipping', isSubscriptionOnly);
  if (isSubscriptionOnly) {
    summary?.classList.remove('shipping-progress-complete');
    return;
  }

  const tier2 = SHIPPING_PROGRESS_DEFAULT_TIER_2_THRESHOLD;
  const tier3 = SHIPPING_PROGRESS_DEFAULT_TIER_3_THRESHOLD;
  const totalPrice = Number(cart.total_price) || 0;

  const isComplete = totalPrice >= tier3 || hasRealFreeShipping(cart);
  summary?.classList.toggle('shipping-progress-complete', isComplete);

  if (isComplete) return;

  const message = document.getElementById('smart-cart-footer-shipping-progress-message');
  const fill = document.getElementById('smart-cart-footer-shipping-progress-fill');

  if (totalPrice < tier2) {
    const missing = tier2 - totalPrice;
    if (message)
      message.innerHTML = `Brakuje Ci <span class="font-semibold">${formatShippingProgressMoney(missing)}</span> do dostawy za <span class="font-semibold">7,99 zł</span>`;
  } else {
    const missing = tier3 - totalPrice;
    if (message)
      message.innerHTML = `Brakuje Ci <span class="font-semibold">${formatShippingProgressMoney(missing)}</span> do darmowej dostawy`;
  }

  const fillPercent = Math.max(0, Math.min(100, (totalPrice / tier3) * 100));
  if (fill) fill.style.width = `${fillPercent}%`;
};

document.addEventListener('rebuy:cart.change', () => {
  setTimeout(updateShippingProgressBar, 200);
  setTimeout(updateFooterShippingProgress, 200);
  setTimeout(setShippingProgressInfoButtonListener, 200);
});
document.addEventListener('rebuy:cart.ready', () => {
  setTimeout(updateShippingProgressBar, 200);
  setTimeout(updateFooterShippingProgress, 200);
  setTimeout(setShippingProgressInfoButtonListener, 200);
});
